/**
 * @file Операторы сравнения для фильтрации каталога.
 * Используются в определениях фильтров для проверки соответствия значений элементов критериям.
 */

/**
 * Проверяет, является ли значение непустым Set.
 * @param {*} values
 * @returns {boolean}
 */
function hasValues(values) {
  return values instanceof Set && values.size > 0
}

/**
 * Проверяет, что числовое значение элемента не меньше значения фильтра.
 * @param {number|null} itemValue - Значение элемента.
 * @param {number|null} filterValue - Минимально допустимое значение.
 * @returns {boolean}
 */
function greaterThanOrEqual(itemValue, filterValue) {
  return (
    Number.isFinite(itemValue) &&
    Number.isFinite(filterValue) &&
    itemValue >= filterValue
  )
}

/**
 * Проверяет, содержит ли Set значений элемента хотя бы одно из значений фильтра.
 * @param {Set} itemValues - Значения элемента.
 * @param {Set} filterValues - Значения фильтра.
 * @returns {boolean}
 */
function includesAny(itemValues, filterValues) {
  if (!hasValues(itemValues) || !hasValues(filterValues)) return false

  return [...filterValues].some((value) => itemValues.has(value))
}

/**
 * Проверяет, содержит ли Set значений элемента все значения фильтра.
 * @param {Set} itemValues - Значения элемента.
 * @param {Set} filterValues - Значения фильтра.
 * @returns {boolean}
 */
function includesAll(itemValues, filterValues) {
  if (!hasValues(itemValues) || !hasValues(filterValues)) return false

  return [...filterValues].every((value) => itemValues.has(value))
}

export { greaterThanOrEqual, includesAll, includesAny }
